class AWSService {
  constructor() {
    this.lambdaEndpoint = 'https://huxti71ynj.execute-api.us-east-1.amazonaws.com/chat';
    this.initialized = false;
  }

  async initialize() {
    if (this.initialized) return;

    try {
      this.initialized = true;
      console.log('✅ Lambda endpoint configured');
    } catch (error) {
      console.error('❌ Failed to initialize AWS service:', error);
    }
  }

  isConfigured() {
    return this.initialized;
  }

  async sendMessage(message, conversationHistory = []) {
    if (!this.isConfigured()) {
      throw new Error('AWS service not configured');
    }

    try {
      // ✅ CORRECT: Send only message and history
      // ❌ DO NOT send system prompt (it's stored in Lambda)
      const response = await fetch(this.lambdaEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          message: message,
          history: conversationHistory.slice(-20)  // Last 20 messages only
        })
      });

      if (!response.ok) {
        throw new Error(`Lambda responded with status ${response.status}`);
      }

      const data = await response.json();

      // Handle the Lambda response
      return {
        response: data.response || data.message || 'No response from Lambda',
        history: data.history || conversationHistory,
        remainingRequests: data.remaining_requests
      };

    } catch (error) {
      console.error('Lambda API error:', error);
      throw new Error(error.message || 'Failed to get AI response');
    }
  }

  getMockResponse(message) {
    const responses = [
      "This is a mock response. Configure AWS Cognito Identity Pool to use real Bedrock AI.",
      "I'm a placeholder response. Set up REACT_APP_COGNITO_IDENTITY_POOL_ID in your .env file to enable AI.",
      "Mock mode active. Deploy the CloudFormation stack and configure environment variables to use AWS Bedrock."
    ];
    return responses[Math.floor(Math.random() * responses.length)];
  }
}

export default new AWSService();
